export enum HomeRowCardColumnWidth {
  ADDRESS = 2.5,
  TEAM = 1,
  TIMELINE = 1.5,
  STATUS = 1,
  VISIBILITY = 1,
  DATES = 1.5,
  ACTION_ITEMS = 1.5,
}
